import React, { Component } from 'react';
import { component_tool } from '../../../tool'
import { WizDataAuthSelect } from '../../common'

const { WizButton, WizCard, WizAntdForm, WizRow, WizCol, WizRadio } = component_tool
class DataAuthSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  handleSubmit = e => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        //values['dataAuth'] = this.dataAuth
        console.log('Received values of form: ', values);
      }
    });
  };

  /**
     * 重置表单
     */
  handleReset = () => {
    //重置表单
    this.props.form.resetFields();
  };

  render() {
    let { form } = this.props
    let initialValue = {
      orgIds: [{ id: 89, name: "yuyuyu" }],
      positionIds: [{ id: 81, name: '213131' }],
      positionCategoryIds: [{ id: 42, name: '2020Arieltest' }],
      personIds: [{ id: '459924dca47b90308c87296327c8b400',  userName: 'test031715d01',fullName:'test0317150d13' }]
    }
    
    return (
      <WizCard title={'数据权限选择'} icon='0'>
        <WizAntdForm onSubmit={this.handleSubmit}>
          {
            form.getFieldDecorator('dataAuth', { initialValue: Object.assign({}, initialValue) })(
              <WizDataAuthSelect />
            )
          }
          <WizAntdForm.Item wrapperCol={{ span: 12, offset: 6 }}>
            <WizRow>
              <WizCol span={24} style={{ textAlign: 'center' }}>
                <WizButton type="primary" htmlType="submit">
                  保存
              </WizButton>
                <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>
                  重置
              </WizButton>
              </WizCol>
            </WizRow>
          </WizAntdForm.Item>
        </WizAntdForm>

      </WizCard>
    )
  }
}

export default WizAntdForm.create()(DataAuthSelect);